import apiClient, { extractData } from "./client";

export async function createEvaluationRound(data) {
  const response = await apiClient.post("/evaluations/rounds", data);
  return extractData(response);
}

export async function getEvaluationRounds() {
  const response = await apiClient.get("/evaluations/rounds");
  return extractData(response);
}

export async function getEvaluationRound(id) {
  const response = await apiClient.get(`/evaluations/rounds/${id}`);
  return extractData(response);
}

export async function updateEvaluationRound(id, data) {
  const response = await apiClient.patch(`/evaluations/rounds/${id}`, data);
  return extractData(response);
}

export async function cloneEvaluationRound(id, data = {}) {
  const response = await apiClient.post(
    `/evaluations/rounds/${id}/clone`,
    data || {},
  );
  return extractData(response);
}

export async function spreadEvaluationRound(id, data = {}) {
  const response = await apiClient.post(
    `/evaluations/rounds/${id}/spread`,
    data || {},
  );
  return extractData(response);
}

export async function addEvaluationRatersByJobTitle(id, data) {
  const response = await apiClient.post(
    `/evaluations/rounds/${id}/add-raters-by-job-title`,
    data || {},
  );
  return extractData(response);
}

export async function activateEvaluationRound(id) {
  const response = await apiClient.post(`/evaluations/rounds/${id}/activate`);
  return extractData(response);
}

export async function closeEvaluationRound(id) {
  const response = await apiClient.post(`/evaluations/rounds/${id}/close`);
  return extractData(response);
}

export async function deleteEvaluationRound(id) {
  const response = await apiClient.delete(`/evaluations/rounds/${id}`);
  return extractData(response);
}

export async function suggestEvaluationRaters(employeeId) {
  const response = await apiClient.get(
    `/evaluations/suggest-raters/${employeeId}`,
  );
  return extractData(response);
}

export async function setEvaluationSubjectRaters(subjectId, raters) {
  const payload = Array.isArray(raters)
    ? { raters }
    : { raters: raters?.raters || [] };
  const response = await apiClient.put(
    `/evaluations/subjects/${subjectId}/raters`,
    payload,
  );
  return extractData(response);
}

export async function getMyPendingEvaluations() {
  const response = await apiClient.get("/evaluations/my-pending");
  return extractData(response);
}

export async function getMyPendingEvaluationCount() {
  const response = await apiClient.get("/evaluations/my-pending-count");
  return extractData(response);
}

export async function getMySubmittedEvaluations() {
  const response = await apiClient.get("/evaluations/my-submitted");
  return extractData(response);
}

export async function getMyEvaluationResults() {
  const response = await apiClient.get("/evaluations/my-results");
  return extractData(response);
}

export async function getEvaluationSubjectResult(subjectId) {
  const response = await apiClient.get(
    `/evaluations/subjects/${subjectId}/result`,
  );
  return extractData(response);
}

export async function submitEvaluation(raterRowId, data) {
  const response = await apiClient.post(
    `/evaluations/raters/${raterRowId}/submit`,
    data,
  );
  return extractData(response);
}
